/* eslint-disable no-new */
import Vue from 'vue';
import App from './App.vue';
import { createRouter, } from './router/index';
import { createStore, } from './store/index';
import titleMixin from './util/title';
import $http from './plug/$http/$http';
import util from './util/util';
import headerNav from '@/components/headerNav/headerNav';
import footerNav from '@/components/footerNav/footerNav';
import doctorSwiper from '@/components/doctorSwiper/doctorSwiper';
import crumbsNav from '@/components/crumbsNav/crumbsNav';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.component('header-nav', headerNav);
Vue.component('footer-nav', footerNav);
Vue.component('doctor-swiper', doctorSwiper);
Vue.component('crumbs-nav', crumbsNav);
Vue.use(ElementUI);
Vue.mixin(titleMixin);
Vue.use($http);
Vue.use(util);
const router = createRouter();
const store = createStore();
const app = new Vue({
  router,
  store,
  components: { App, },
  template: '<App/>',
});

router.beforeResolve((to, from, next) => {
  const matched = router.getMatchedComponents(to);
  const prevMatched = router.getMatchedComponents(from);
  // 我们只关心之前没有渲染的组件
  // 所以我们对比它们，找出两个匹配列表的差异组件
  let diffed = false;
  const activated = matched.filter((c, i) => {
    return diffed || (diffed = (prevMatched[i] !== c));
  });
  if (!activated.length) {
    return next();
  }
  // 这里如果有加载指示器(loading indicator)，就触发
  Promise.all(activated.map(c => {
    if (c.asyncData) {
      return c.asyncData({ store, route: to, app: app, });
    }
  })).then(() => {
    // 停止加载指示器(loading indicator)
    if ($('#web-app').html() == '')app.$mount('#web-app');
    next();
  }).catch(next);
}),
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});



// WEBPACK FOOTER //
// ./src/main.js